import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.category',
    method: 'get',
    params,
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.category/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.category/${id}`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.category/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.category',
    method: 'post',
    data,
  })
}
